module.exports = __webpack_public_path__ + "img/map-01.4dea3483.svg";